import { combineReducers } from './utils';
import content from './content/content';
import contentSettings from './content/settings';

export default combineReducers({
    content,
    contentSettings,
});



// WEBPACK FOOTER //
// ./src/reducers/content.js